import { Send, Phone, MessageCircle } from 'lucide-react';
import { trackContactClick, type ContactChannel } from '@/lib/analytics';

export const PHONE_NUMBER = '+380639884342';
export const PHONE_DISPLAY = '+380 63 988 4342';

export const MESSENGERS: {
  channel: ContactChannel;
  label: string;
  href: string;
  bg: string;
  Icon: typeof Send;
}[] = [
  {
    channel: 'telegram',
    label: 'Telegram',
    href: `https://t.me/${PHONE_NUMBER}`,
    bg: 'bg-[#229ED9] hover:bg-[#1c8dc2]',
    Icon: Send,
  },
  {
    channel: 'viber',
    label: 'Viber',
    href: `viber://chat?number=%2B${PHONE_NUMBER.replace('+', '')}`,
    bg: 'bg-[#7360F2] hover:bg-[#5f4dd8]',
    Icon: Phone,
  },
  {
    channel: 'whatsapp',
    label: 'WhatsApp',
    href: `https://wa.me/${PHONE_NUMBER.replace('+', '')}`,
    bg: 'bg-[#25D366] hover:bg-[#1fb857]',
    Icon: MessageCircle,
  },
];

/**
 * Ряд кнопок месенджерів. variant='full' — кнопки з підписами (форма, футер),
 * variant='icons' — тільки круглі іконки (компактні місця).
 */
export const MessengerButtons = ({ variant = 'full' }: { variant?: 'full' | 'icons' }) => (
  <div className="flex flex-wrap gap-3">
    {MESSENGERS.map(({ channel, label, href, bg, Icon }) => (
      <a
        key={channel}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={label}
        onClick={() => trackContactClick(channel)}
        className={`${bg} text-white transition-colors duration-200 flex items-center justify-center ${
          variant === 'full'
            ? 'gap-2 px-4 py-2.5 rounded-full text-sm font-semibold'
            : 'w-10 h-10 rounded-full'
        }`}
      >
        <Icon className="w-4 h-4" />
        {variant === 'full' && label}
      </a>
    ))}
  </div>
);

/** Плаваючі кнопки месенджерів — завжди під рукою, критично для мобільних */
export const FloatingContact = () => (
  <div className="fixed bottom-5 right-4 z-40 flex flex-col gap-3">
    {MESSENGERS.map(({ channel, label, href, bg, Icon }) => (
      <a
        key={channel}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={label}
        onClick={() => trackContactClick(channel)}
        className={`${bg} text-white w-12 h-12 rounded-full flex items-center justify-center shadow-lg hover:scale-105 transition-all duration-200`}
      >
        <Icon className="w-5 h-5" />
      </a>
    ))}
  </div>
);
